export default __webpack_public_path__ + "static/media/earthspec1k.de08296c.jpg";